var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',{attrs:{"showTab":true}},[(_vm._config)?_c(_vm.temp,{tag:"component"}):_vm._e(),_c('BottomTab')],1)}
var staticRenderFns = []

export { render, staticRenderFns }